import { MouseEvent, useEffect, useState } from "react";
import classNames from "classnames";
import ArrowRightSquareIcon from "@svg/new-explore/arrow-right-square";
import { ExploreFilterComponentProps } from "@modules/new-explore/types";
import { Checkbox } from "@shared/components/checkbox";
import { CHECKBOX_SIZE } from "@shared/components/checkbox/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { ExploreCategory as ExploreCategoryType } from "@modules/layout/modal/explore/category";
import { toFarsiNumber } from "@utils/digits";
import Image from "next/image";
import { categoryPic } from "./categoryPic";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExploreCategory: React.FC<ExploreFilterComponentProps> = () => {
  const { activeFilters, categoryData } = useExplorePreloadedData();

  const activeCategoryFilter = activeFilters?.category_id;
  const activeCategoryIds = activeCategoryFilter?.filter_value.map((item) =>
    Number(item.id)
  );

  const [initialFilter, setInitialFilter] = useState<boolean>(false);
  const [currentParent, setCurrentParent] = useState<number | undefined>(
    undefined
  );

  const { removeFilterByValue, removeFilterByKey, addFilter } = useExplore();
  const [currentList, setCurrentList] = useState<
    ExploreCategoryType[] | undefined
  >(categoryData);
  const [level, setLevel] = useState(1);

  const [parentList, setParentList] = useState<{
    [key: number]: ExploreCategoryType & { parent: number | undefined };
  }>({});

  useEffect(() => {
    setInitialFilter(false);
  }, [activeCategoryFilter]);

  useEffect(() => {
    if (!currentList?.length) setCurrentList(categoryData);
  }, [categoryData]);

  const openChildrenList = (id: number, changeFilter = true) => {
    const list = currentList?.find((item) => item.id === id)!;
    if (list) {
      if (list && !parentList[list.id])
        setParentList((prev) => ({
          ...prev,
          [list.id]: { ...list, parent: currentParent },
        }));
      setInitialFilter(true);
      setCurrentList(list.childs);
      setCurrentParent(id);
      setLevel(level + 1);

      const theCategory = categoryData?.find((item) => item.id === id);
      if (changeFilter)
        handleOnChange(
          id,
          true,
          theCategory?.persian_name || theCategory?.name || ""
        );
    }
  };

  const showAllCategories = () => {
    removeFilterByKey("category_id");
    setCurrentList(categoryData);
    setLevel(1);
    setCurrentParent(undefined);
  };

  const parentListSelected = currentParent
    ? parentList[currentParent]
    : undefined;

  const handleOnChange = (
    filterValue: string | number,
    checked: boolean,
    name: string
  ) => {
    let isSingle = false;
    if (
      (activeCategoryIds?.includes(parentListSelected?.id || 0) ||
        filterValue === String(parentListSelected?.id)) &&
      checked
    ) {
      isSingle = true;
    }
    checked
      ? addFilter({
          filterName: "category_id",
          value: String(filterValue),
          name: name,
          isSingle,
          withReplace: isSingle,
        })
      : removeFilterByValue("category_id", String(filterValue));
  };

  const handleClickOnParent = (
    e: MouseEvent<HTMLLIElement, globalThis.MouseEvent>,
    item: ExploreCategoryType
  ) => {
    e.stopPropagation();
    e.preventDefault();
    item.childs
      ? openChildrenList(item.id)
      : handleOnChange(item.id, true, item.persian_name || item.name);
    setLevel(level + 1);
  };

  const parentlabel = ` ${
    (parentListSelected?.persian_name || parentListSelected?.name)?.includes(
      "آموزش‌های"
    )
      ? "همه‌ی"
      : "همه‌ی آموز‌ش های"
  } ${parentListSelected?.persian_name || parentListSelected?.name}${
    parentListSelected?.count !== undefined
      ? `(${toFarsiNumber(parentListSelected?.count)})`
      : ""
  }`;
  useEffect(() => {
    if (!initialFilter) {
      if (activeCategoryIds?.length) {
        let isExist = false;
        categoryData?.map((catItm) => {
          if (activeCategoryIds?.includes(catItm.id)) {
            openChildrenList(catItm.id, false);
            setLevel(level + 1);
            isExist = true;
          }
        });
        if (!isExist && activeCategoryIds?.length && level === 1) {
          openChildrenList(
            activeCategoryFilter?.filter_value[0].parentId || 0,
            false
          );
        }
      } else {
        setCurrentList(categoryData);
        setLevel(1);
        setCurrentParent(undefined);
      }
    }
  }, [activeCategoryFilter, currentList]);

  return (
    <>
      {level > 1 ? (
        <span
          className="flex items-center cursor-pointer text-fds-secondary body-sm mb-3"
          onClick={showAllCategories}
        >
          <ArrowRightSquareIcon
            width={20}
            height={20}
            className="ml-1.5 text-fds-secondary"
          />
          {activeCategoryFilter?.filter_value.length
            ? " حذف و مشاهده همه دسته‌بندی‌ها"
            : "دیدن همه دسته‌بندی‌ها"}
        </span>
      ) : null}

      {parentListSelected ? (
        <span className="flex items-center gap-x-2   py-3  ">
          <div className="selectedImage flex items-center">
            <Image
              src={categoryPic[parentListSelected.id] || ""}
              height={20}
              width={20}
              alt={parentListSelected.name}
            />
          </div>
          <p className="text-fds-brand title-md-demibold">
            {parentListSelected.name}
          </p>
        </span>
      ) : undefined}
      <ul
        className={classNames(
          level > 1 &&
            "border-r relative border-dashed border-r-fds-brand-light mr-[18px] pr-[18px] mt-3 "
        )}
      >
        {level > 1 && (
          <div className="absolute -right-1  w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-8 mb-1 border-t-fds-brand-light" />
        )}
        {level > 1 && parentListSelected && (
          <li
            className={classNames(
              "flex items-center py-2.5   text-sm pt-0 font-medium px-1 text-fds-secondary cursor-pointer justify-between lg:justify-start",
              !activeCategoryFilter ? "font-normal" : "font-medium"
            )}
          >
            <Checkbox
              id={String(parentListSelected?.id)}
              label={parentlabel}
              selected={
                activeCategoryIds?.includes(parentListSelected?.id) || false
                  ? "checked"
                  : "unChecked"
              }
              className="text-fds-secondary"
              size={CHECKBOX_SIZE.LARGE}
              handleOnChange={(id, checked) =>
                handleOnChange(id, checked, parentlabel)
              }
            />
          </li>
        )}
        {currentList
          ?.filter((itm) => (level === 1 ? itm.childs : true))
          ?.map((item) => {
            const isSelected = activeCategoryIds?.includes(item.id) || false;
            return (
              <li
                key={item.id}
                className={classNames(
                  "flex items-center py-1.5    px-1 text-fds-secondary cursor-pointer justify-between lg:justify-start",
                  "body-md"
                )}
                onClick={(e) =>
                  item.childs && level === 1
                    ? handleClickOnParent(e, item)
                    : undefined
                }
              >
                {item.childs && level === 1 ? (
                  <>
                    {item.childs && (
                      <Image
                        src={categoryPic[item.id]}
                        height={20}
                        width={20}
                        alt={item.name}
                      />
                    )}
                    <span className="mr-2">
                      {item.persian_name || item.name}
                    </span>
                  </>
                ) : (
                  <Checkbox
                    id={String(item.id)}
                    label={`${item.persian_name || item.name} ${
                      item.count !== undefined
                        ? `(${toFarsiNumber(item.count)})`
                        : ""
                    }`}
                    selected={isSelected ? "checked" : "unChecked"}
                    size={CHECKBOX_SIZE.LARGE}
                    handleOnChange={(id, checked) =>
                      handleOnChange(
                        id,
                        checked,
                        item.persian_name || item.name
                      )
                    }
                    className="text-fds-secondary"
                  />
                )}
              </li>
            );
          })}
      </ul>
    </>
  );
};

export default ExploreCategory;
